import MainMenu from 'components/menus/MainMenu';
import MainNav from 'components/navs/MainNav';
import React from 'react';
import IdleTimeout from "../components/utils/IdleTimeout";
import ErrorModal from "../components/modals/ErrorModal";
import {useSelector} from "react-redux";
import {Skeleton} from "primereact/skeleton";
import {usePageTracking} from "../hooks/pageTracking";

const MainLayout = ({children}) => {
    const status = useSelector(state => state.status.status);
    usePageTracking();

    return (
        <>
            <IdleTimeout />
            <div className="main-layout">
                <div className="top-area">
                    <MainNav />
                </div>
                <div className="bottom-area">
                    {status === 'init' ? (<div className="p-panelmenu"><Skeleton width="100%" height="100%"></Skeleton></div>) : (<MainMenu />)}
                    <div className="content">
                        {status === 'init' ? (<div style={{paddingBottom: "20px", height: "100%"}}><Skeleton width="100%" height="100%"></Skeleton></div>) : children}
                    </div>
                </div>
            </div>
            <ErrorModal />
        </>
    )
}

export default MainLayout;
